import { createSlice }       from '@reduxjs/toolkit';
import * as locationReducers from 'Redux/Reducers/Location';
import { Location }          from 'Domain/Models';

export interface ILocationState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, Location>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const locationSlice = createSlice({
  name: 'location',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: locationReducers,
});
